import { history } from '../app/app.route.history';

export const setHistory = (location: any) => {
  const { pathname, search } = location;
  history.replace({ pathname, search });
};
